"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$irohaChar = exports.$romanDigits = exports.romanDigits = exports.$arabicDigits = exports.arabicDigits = exports.$kanjiDigits = exports.kanjiDigits = exports.$_EOL = exports.ptn$_EOL = exports.$__ = exports.ptn$__ = exports.$_ = exports.ptn$_ = void 0;
const num_1 = require("../../../law/num");
const factory_1 = require("../factory");
exports.ptn$_ = "[ 　\t]*";
exports.$_ = factory_1.factory
    .withName("OPTIONAL_WHITESPACES")
    .regExp(new RegExp(`^${exports.ptn$_}`));
exports.ptn$__ = "[ 　\t]+";
exports.$__ = factory_1.factory
    .withName("WHITESPACES")
    .regExp(new RegExp(`^${exports.ptn$__}`));
exports.ptn$_EOL = "[ 　\t]*\r?\n";
exports.$_EOL = factory_1.factory
    .withName("OPTIONAL_WHITESPACES_AND_EOL")
    .regExp(new RegExp(`^${exports.ptn$_EOL}`));
exports.kanjiDigits = "〇一二三四五六七八九十百千";
exports.$kanjiDigits = factory_1.factory
    .withName("kanjiDigits")
    .regExp(new RegExp(`^[${exports.kanjiDigits}]+`));
exports.arabicDigits = "0123456789０１２３４５６７８９";
exports.$arabicDigits = factory_1.factory
    .withName("arabicDigits")
    .regExp(new RegExp(`^[${exports.arabicDigits}]+`));
exports.romanDigits = "iIｉＩvVｖＶxXｘＸ";
exports.$romanDigits = factory_1.factory
    .withName("romanDigits")
    .regExp(new RegExp(`^[${exports.romanDigits}]+`));
exports.$irohaChar = factory_1.factory
    .withName("irohaChar")
    .regExp(new RegExp(`^[${num_1.irohaChars}]`));
//# sourceMappingURL=lexical.js.map